import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import farmImage from '../../assets/images/img-001.svg';
import calculatorImg from '../../assets/images/calculator.svg';

import "./farm-item.css";
function FarmItem() {
	return (
		<>
			<div className="farm-item">
				<div className="form-item-detail">
					<header className="item-header d-flex justify-content-between mb-4">
						<div className="icon-image-holder position-relative">
							<img className="img-fluid" src={farmImage} alt="" />
						</div>
						<div className="title-holder">
							<strong className="farm-title d-block mb-2 text-uppercase text-end">Cardano-BNB</strong>
							<ul className="list-unstyled farm-tags-list d-flex justify-content-end">
								<li className="d-flex"><span className="check-in-cirlce position-relative me-2"></span>Core</li>
								<li>40K</li>
							</ul>
						</div>
					</header>
					<ul className="farm-stats list-unstyled mb-4">
						<li className="d-flex justify-content-between mb-2">
							<span className="stat-title">APR:</span>
							<strong className="stat-title">52.41% <img className="icon-calculator" src={calculatorImg} alt="" /></strong>
						</li>
						<li className="d-flex justify-content-between mb-2">
							<span className="stat-title">Earn:</span>
							<strong className="stat-title">Cardano + Fees</strong>
						</li>
					</ul>
					<div className="earned-block d-flex flex-column mb-4">
						<span className="earned-text text-uppercase mb-1">Cardano Earned</span>
						<div className="d-flex justify-content-between align-items-center mb-1">
							<span className="cake-value">0.000</span>
							<button className="btn-harvest">Harvest</button>
						</div>
						<span className="earned-text">Cardano-BNB LP Staked</span>
					</div>
					<Link to="/wallet" className="d-block text-center btn-connect-wallet">Connect Wallet</Link>
				</div>
				<div className="detail-btn-holder text-center">
					<span className="btn-detail">
						<span className="show-text">Details <FontAwesomeIcon className="ms-2" icon={faAngleDown} /></span>
						<span className="hide-text">Hide <FontAwesomeIcon className="ms-2" icon={faAngleUp} /></span>
					</span>
				</div>
				<footer className="item-footer">
					<div className="total-stats d-flex justify-content-between mb-4">
						<span>Total Liquidity:</span>
						<span>$531,825,570</span>
					</div>
					<ul className="list-unstyled footer-links">
						<li className="mb-2"><Link to="">Get Cardano-BNB LP <FontAwesomeIcon className="ms-2" icon={faExternalLinkAlt} /></Link></li>
						<li className="mb-2"><Link to="">View Contract <FontAwesomeIcon className="ms-2" icon={faExternalLinkAlt} /></Link></li>
						<li className="mb-2"><Link to="">See Pair Info <FontAwesomeIcon className="ms-2" icon={faExternalLinkAlt} /></Link></li>
					</ul>
				</footer>
			</div>
		</> 
	);
}

export default FarmItem;
